<template>
  <div class="details-container">
    

    <div class="detail-field-container">
      <img
        :class="{
          'detail-field-icon': true,
          'detail-icon-disabled': !details.phone,
        }"
        src="/icons/details/phone.svg"
      />
      <input
        type="text"
        ref="phoneField"
        :class="
          phone_mask_full ? 'detail-field-input' : 'detail-field-input c-grey'
        "
        :value="details.phone"
        @complete="onPhoneMaskComplete"
        v-imask="phoneMask"
        placeholder="Phone"
      />
    </div>

    <div class="detail-field-container">
      <img
        :class="{
          'detail-field-icon': true,
          'detail-icon-disabled': !details.name,
        }"
        src="/icons/details/person.svg"
      />
      <input
        type="text"
        class="detail-field-input"
        :placeholder="$t('create_preorder.name_ph')"
        maxlength="64"
        v-model="details.name"
      />
    </div>

    <div class="detail-field-container" v-if="mode == 'delivery'">
      <img
        :class="{
          'detail-field-icon': true,
          'detail-icon-disabled': !details.address,
        }"
        src="/icons/details/house.svg"
      />
      <input
        type="text"
        class="detail-field-input"
        id="addressField"
        v-model="details.address"
        :placeholder="$t('create_preorder.address_ph')"
      />
    </div>

    <template v-if="mode == 'delivery'">
      <div
        class="detail-field-container"
        v-for="detail in cafe.delivery.address_details"
        :key="detail"
      >
        <img
          :class="{
            'detail-field-icon': true,
            'detail-icon-disabled': !details_inputs[detail],
          }"
          src="/icons/details/house.svg"
        />
        <input
          type="text"
          class="detail-field-input"
          v-model="details_inputs[detail]"
          :placeholder="$t('create_preorder.details_types.' + detail)"
        />
      </div>
    </template>

    <div class="detail-field-container">
      <img
        :class="{
          'detail-field-icon': true,
          'detail-icon-disabled': details.takeaway_date == 'none',
        }"
        src="/icons/details/calendar.svg"
      />
      <select
        :class="{
          'detail-field-input': true,
          'detail-field-disabled': details.takeaway_date == 'none',
          'detail-field-ghost': true,
        }"
        v-model="details.takeaway_date"
      >
        <option :value="'none'" disabled>
          {{ $t("create_preorder.date_ph") }}
        </option>
        <option :value="null">
          {{ $t("create_preorder.asap") }}
        </option>
        <option
          v-for="date in availableTakeawayDates"
          :key="+date"
          :value="date"
        >
          {{ prettyFormatDate(date) }} {{ date | formatTime }}
        </option>
      </select>
      <div
        class="detail-field-real-value"
        v-if="details.takeaway_date != 'none' && details.takeaway_date != null"
      >
        {{ prettyFormatDate(details.takeaway_date) }}
        <span class="sub-real-value" v-if="details.takeaway_date">
          {{ details.takeaway_date | formatTime }}
        </span>
      </div>
      <div
        class="detail-field-real-value"
        v-else-if="details.takeaway_date == null"
      >
        {{ $t("create_preorder.asap") }}
      </div>
      <div class="detail-field-real-value detail-field-disabled" v-else>
        {{ $t("create_preorder.date_ph") }}
      </div>
      <div style="width: inherit">
        <img
          :class="{
            arrow: true,
            'detail-icon-disabled': details.takeaway_date == 'none',
          }"
          src="/icons/details/arrow-white.svg"
        />
      </div>
    </div>

    <div
      class="detail-field-container"
      v-if="mode != 'reserve' && cafe.delivery.use_guests_count"
    >
      <img
        class="detail-field-icon"
        :src="
          details.guests_count > 0
            ? '/icons/details/cutlery.svg'
            : '/icons/details/cutlery-eco.svg'
        "
      />
      <select
        :class="{
          'detail-field-input': true,
          'detail-green': details.guests_count == 0,
        }"
        v-model="details.guests_count"
      >
        <option v-for="n in 6" :key="n" :value="n - 1">
          {{
            n - 1 == 0
              ? $t("create_preorder.no_guests")
              : `${n - 1} ` + $tc("units.guests", n - 1)
          }}
        </option>
      </select>
      <img
        :class="{
          arrow: true,
        }"
        src="/icons/details/arrow-white.svg"
        v-if="details.guests_count !== 0"
      />
      <img
        src="/icons/details/arrow-green.svg"
        class="arrow"
        v-if="details.guests_count == 0"
      />
    </div>

    <div class="detail-field-container" v-else-if="mode == 'reserve'">
      <img
        :class="{
          'detail-field-icon': true,
          'detail-icon-disabled': !details.guests_count,
        }"
        src="/icons/details/person.svg"
      />
      <select
        :class="{
          'detail-field-input': true,
        }"
        v-model="details.guests_count"
      >
        <option v-for="n in 5" :key="n" :value="n">
          {{ `${n} ` + $tc("units.reserve_guests", n) }}
        </option>
      </select>
      <img
        :class="{
          arrow: true,
        }"
        src="/icons/details/arrow-white.svg"
      />
    </div>

    <div class="detail-field-container" v-if="mode == 'preorder'">
      <img
        class="detail-field-icon"
        :src="
          !details.with_reservation
            ? '/icons/details/takeaway.svg'
            : '/icons/details/reservation.svg'
        "
      />
      <select
        :class="{
          'detail-field-input': true,
        }"
        v-model="details.with_reservation"
      >
        <option :value="false">{{ $t("create_preorder.takeaway") }}</option>
        <option :value="true">
          {{ $t("create_preorder.with_reservation") }}
        </option>
      </select>
      <img
        :class="{
          arrow: true,
        }"
        src="/icons/details/arrow-white.svg"
      />
    </div>

    <div class="detail-field-container" v-if="mode != 'reserve'">
      <img
        :class="{
          'detail-field-icon': true,
          'detail-icon-disabled': !details.pay_method,
        }"
        :src="
          details.pay_method == 'card'
            ? '/icons/details/card.svg'
            : '/icons/details/cash.svg'
        "
      />
      <select
        :class="{
          'detail-field-input': true,
          'detail-field-disabled': !details.pay_method,
        }"
        v-model="details.pay_method"
      >
        <option :value="null" disabled>
          {{ $t("create_preorder.payment_ph") }}
        </option>
        <option :value="'cash'">
          {{ $t("create_preorder.payment_cash") }}
        </option>
        <option :value="'card'">
          {{ $t("create_preorder.payment_card") }}
        </option>
      </select>
      <img
        :class="{
          arrow: true,
          'detail-icon-disabled': !details.pay_method,
        }"
        src="/icons/details/arrow-white.svg"
      />
    </div>
    <div class="bonus-balance-container">
      <div class="bonus-balance-text">
        {{ $t("create_preorder.bonus_balance") }}
      </div>
      <div
        :class="{
          'bonus-balance-value': true,
          'bonus-balance-zero': bonus_balance == 0,
        }"
      >
        {{ bonus_balance }}{{ currency.symbol }}
      </div>
    </div>

    <CreationComment class="comment-block" v-model="details.comment" />
  </div>
</template>

<script>
import moment from "moment";

import CreationComment from "@/components/details/CreationComment.vue";
import QueueAPI from "@/api/queue";

import { IMaskDirective } from "vue-imask";

import ScheduleService from "@/services/schedule";

let gmapAutocomplete = null;

export default {
  data() {
    return {
      details: {
        name: null,
        phone: null,
        address: null,
        guests_count: 0,
        takeaway_date: "none",
        pay_method: null,
        comment: null,
        with_reservation: false,
        address_details: null,
      },

      details_inputs: { floor: null, entrance: null, flat: null },

      phone_mask_full: false,

      bonus_balance: 0,
    };
  },
  components: {
    CreationComment,
  },
  watch: {
    details: {
      handler() {
        this.validateDetails();
      },
      deep: true,
    },
  },
  props: {
    value: Object,
    mode: String,
  },
  methods: {
    prettyFormatDate(date) {
      if (moment().isSame(date, "day")) return this.$t("friendly_dates.today");
      if (moment().add(1, "day").isSame(date, "day"))
        return this.$t("friendly_dates.tomorrow");

      return moment(date).format("DD.MM.YYYY");
    },
    emitReady(is_ready) {
      this.$emit("ready", is_ready);
    },
    onPhoneMaskComplete(ev) {
      this.details.phone = ev.detail.unmaskedValue;
      this.phone_mask_full = true;
      this.searchClient();
    },
    searchClient() {
      QueueAPI.searchClient(this.details.phone)
        .then((data) => {
          if (!data.client || !data.balance) {
            this.bonus_balance = 0;
          } else {
            this.bonus_balance = data.balance.bonuses;
            if (!this.details.name) this.details.name = data.client.name;
            if (!this.details.address)
              this.details.address = data.client.address;
          }
        })
        .catch((error) => {});
    },
    validateDetails() {
      if (!this.details.name) {
        this.emitReady(false);
        return;
      }

      if (!this.details.phone) {
        this.emitReady(false);
        return;
      }

      if (this.mode != "reserve" && !this.details.pay_method) {
        this.emitReady(false);
        return;
      }

      if (this.details.takeaway_date == "none") {
        this.emitReady(false);
        return;
      }

      if (this.mode == "delivery" && !this.details.address) {
        this.emitReady(false);
        return;
      }

      this.details.details_inputs = this.details_inputs;

      let address_tokens = [];

      this.cafe.delivery.address_details.forEach((d) => {
        if (this.details_inputs[d])
          address_tokens.push(
            `${this.$t("create_preorder.details_types." + d)}: ${
              this.details_inputs[d]
            }`
          );
      });

      if (address_tokens.length) {
        this.details.address_details = address_tokens.join(", ");
      }

      this.emitReady(true);
      this.$emit("input", this.details);
    },
    initGoogleMapsAutocomplete() {
      gmapAutocomplete = new window.google.maps.places.Autocomplete(
        document.getElementById("addressField"),
        { types: ["geocode"] }
      );

      gmapAutocomplete.setFields(["formatted_address"]);

      gmapAutocomplete.setComponentRestrictions({
        country: this.$store.state.region.country_code.toLowerCase() || "ua",
      });

      if (this.cafe.address_location) {
        const N = 50;
        const bounds_center = this.cafe.address_location;

        const loc_min = new google.maps.LatLng(
          bounds_center.lat - 0.009 * N,
          bounds_center.lon - 0.009 * N
        );

        const loc_max = new google.maps.LatLng(
          bounds_center.lat + 0.009 * N,
          bounds_center.lon + 0.009 * N
        );

        const bounds = new google.maps.LatLngBounds(loc_min, loc_max);

        gmapAutocomplete.setBounds(bounds);
      }

      gmapAutocomplete.addListener(
        "place_changed",
        this.onGoogleMapsPlaceChanged
      );
    },
    onGoogleMapsPlaceChanged() {
      const place = gmapAutocomplete.getPlace();

      const full_address = place.formatted_address;

      const tokens = full_address.split(",").slice(0, 3);

      this.details.address = tokens.join(",");
    },
    onPhonePasted(ev) {
      if (ev.clipboardData) {
        const text = ev.clipboardData.getData("text");

        let result = text;

        const first_part = this.$store.state.region.phone_code.split("{")[1];

        const phone_code = first_part.split("}")[0];

        let prefix = "";

        let last_ptr = 0;

        for (let i = 0; i < phone_code.length; i++) {
          if (result[last_ptr] != phone_code[i]) {
            prefix += phone_code[i];
          } else {
            last_ptr++;
          }
        }

        const correct_phone = `${prefix}${text}`;

        this.details.phone = correct_phone;
      }
    },
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    availableTakeawayDates() {
      let now = moment();
      let dates = [];

      now = now.add(10 - (now.minutes() % 10), "minutes");
      now = now.add(1, "hour");

      const end_date = moment(now).add(7, "days");

      while (now.isBefore(end_date)) {
        const helper = new ScheduleService.ScheduleHelper(
          this.cafe.schedule,
          now.valueOf()
        );

        if (helper.isOpen()) {
          dates.push(now.toDate());
        }

        if (this.mode == "reserve") {
          now = now.add(30, "minutes");
        } else {
          now = now.add(10, "minutes");
        }
      }

      return dates;
    },
    phoneMask() {
      return {
        mask: this.$store.state.region.phone_code,
        // mask: `{+${this.$store.state.region.phone_code}}-000-000-00-00`,
        lazy: false,
      };
    },
    currency() {
      return this.$store.state.currency;
    },
  },
  directives: {
    imask: IMaskDirective,
  },
  mounted() {
    if (this.value) this.details = this.value;

    if (this.mode == "delivery") {
      this.$nextTick(this.initGoogleMapsAutocomplete);
    }

    if (this.details.details_inputs) this.details_inputs = this.details.details_inputs;

    if (this.mode == "reserve") {
      this.details.guests_count = 1;
    }

    this.$refs.phoneField.addEventListener("paste", this.onPhonePasted);
  },
};
</script>

<style scoped>
.details-container {
  padding: 8vh 2.4vh 2vh;

  padding-bottom: 30vh;
}

.detail-field-container {
  display: flex;
  align-items: center;
  align-content: center;

  padding: 2vh 0;

  border-bottom: 1px solid #908f8d;
}

.detail-field-icon {
  width: auto;
  height: 100%;
  margin-right: 2.4vh;
}

.detail-field-input {
  width: 100%;
  color: #1d1d1b;
  font-size: 2vh;
  outline: none;
  border: 0;
  background: transparent;

  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.detail-field-ghost {
  border: 0;
  background: transparent;
  position: absolute;
  opacity: 0;
  border: none;
}

.detail-field-real-value {
  width: 100% !important;
  line-height: normal;
  min-width: max-content;
  font-size: 2vh;
}

.detail-field-input::placeholder {
  color: #908f8d;
}

.detail-green {
  color: #129b81;
}

.detail-icon-disabled {
  opacity: 0.45;
}

.detail-field-disabled {
  color: #908f8d;
}

.comment-block {
  margin-top: 3vh;
}

.bonus-balance-container {
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 1.4vh 0;

  border-bottom: 1px solid #908f8d;
}

.bonus-balance-text {
  color: #908f8d;
}

.bonus-balance-value {
  color: #129b81;
}

.bonus-balance-zero {
  color: #908f8d;
}

.sub-real-value {
  color: #129b81;
  display: block;
  padding: 0;
  margin: 0;
  line-height: normal;
  min-width: max-content;
}

img.arrow {
  float: right;
  margin: 0;
  width: auto;
  height: 1.5vh;
  transform: rotate(-90deg);
}
select:focus ~ img.arrow {
  transform: rotate(-180deg);
  transition: 0.3s;
}

.detail-field-container {
  height: 7.5vh;
}
</style>